import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachDto } from "../../../models/coach/dto/coach.dto";

export const useGetCurrentAuthenticatedCoach = (organizationId?: string) => {
    const client = useApiClient();
    return useQuery({
        enabled: Boolean(organizationId),
        queryKey: ['currentAuthenticatedCoach', organizationId],
        queryFn: async () => {
            return client.fetchApi<CoachDto, {}>({
                endpoint: `organizations/me/coach?organizationId=${organizationId}`,
                method: 'GET',
            });
        },
    });
};